module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 5);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SHOW_TIMEOUT_MODAL = exports.SHOW_TIMEOUT_MODAL = 'SHOW_TIMEOUT_MODAL';
  var HIDE_TIMEOUT_MODAL = exports.HIDE_TIMEOUT_MODAL = 'HIDE_TIMEOUT_MODAL';
  var USER_LOGOUT = exports.USER_LOGOUT = 'USER_LOGOUT';
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _timeoutModalActions = __webpack_require__(4);

  var timeoutModalActions = _interopRequireWildcard(_timeoutModalActions);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var mapDispatchToProps = _extends({}, timeoutModalActions);

  exports.default = mapDispatchToProps;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var mapStateToProps = function mapStateToProps(state) {
    var _state$sharedDefiniti = state.sharedDefinition,
        sharedDefinition = _state$sharedDefiniti === undefined ? {} : _state$sharedDefiniti;
    var _sharedDefinition$mod = sharedDefinition.modalVisible,
        modalVisible = _sharedDefinition$mod === undefined ? false : _sharedDefinition$mod,
        _sharedDefinition$sta = sharedDefinition.startTimer,
        startTimer = _sharedDefinition$sta === undefined ? null : _sharedDefinition$sta,
        _sharedDefinition$cle = sharedDefinition.clearTimer,
        clearTimer = _sharedDefinition$cle === undefined ? null : _sharedDefinition$cle,
        _sharedDefinition$use = sharedDefinition.userLogout,
        userLogout = _sharedDefinition$use === undefined ? null : _sharedDefinition$use,
        timeoutMessage = sharedDefinition.timeoutMessage,
        timeoutUrl = sharedDefinition.timeoutUrl,
        onTimeout = sharedDefinition.onTimeout;
    return {
      modalVisible: modalVisible,
      startTimer: startTimer,
      clearTimer: clearTimer,
      userLogout: userLogout,
      timeoutMessage: timeoutMessage,
      timeoutUrl: timeoutUrl,
      onTimeout: onTimeout
    };
  };

  exports.default = mapStateToProps;
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _timeoutModalDefinition = __webpack_require__(6);

  var _timeoutModalDefinition2 = _interopRequireDefault(_timeoutModalDefinition);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var sharedDefinition = function sharedDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    var newState = state;
    newState = (0, _timeoutModalDefinition2.default)(newState, action);
    return newState;
  };

  exports.default = sharedDefinition;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.hideTimeoutModal = exports.showTimeoutModal = exports.userLogout = undefined;

  var _timeoutModalTypes = __webpack_require__(0);

  var userLogout = exports.userLogout = function userLogout() {
    return {
      type: _timeoutModalTypes.USER_LOGOUT
    };
  };

  var showTimeoutModal = exports.showTimeoutModal = function showTimeoutModal(startTimer, clearTimer, message, url, onTimeout, userLogout) {
    return {
      type: _timeoutModalTypes.SHOW_TIMEOUT_MODAL,
      modalVisible: true,
      timeoutMessage: message,
      timeoutUrl: url,
      onTimeout: onTimeout,
      startTimer: startTimer,
      clearTimer: clearTimer,
      userLogout: userLogout
    };
  };

  var hideTimeoutModal = exports.hideTimeoutModal = function hideTimeoutModal() {
    return {
      type: _timeoutModalTypes.HIDE_TIMEOUT_MODAL,
      modalVisible: false,
      startTimer: null,
      userLogout: null
    };
  };
  /***/

},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.mapDispatchToProps = exports.mapStateToProps = exports.sharedDefinition = undefined;

  var _reducer = __webpack_require__(3);

  var _reducer2 = _interopRequireDefault(_reducer);

  var _mapStateToProps = __webpack_require__(2);

  var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);

  var _mapDispatchToProps = __webpack_require__(1);

  var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.sharedDefinition = _reducer2.default;
  exports.mapStateToProps = _mapStateToProps2.default;
  exports.mapDispatchToProps = _mapDispatchToProps2.default;
  /***/
},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _timeoutModalTypes = __webpack_require__(0);

  var timeoutModalDefinition = function timeoutModalDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case _timeoutModalTypes.SHOW_TIMEOUT_MODAL:
        return _extends({}, state, {
          modalVisible: action.modalVisible,
          timeoutMessage: action.timeoutMessage,
          timeoutUrl: action.timeoutUrl,
          onTimeout: action.onTimeout,
          startTimer: action.startTimer,
          clearTimer: action.clearTimer,
          userLogout: action.userLogout
        });

      case _timeoutModalTypes.HIDE_TIMEOUT_MODAL:
        return _extends({}, state, {
          modalVisible: action.modalVisible,
          startTimer: action.startTimer,
          userLogout: action.userLogout
        });

      default:
        return state;
    }
  };

  exports.default = timeoutModalDefinition;
  /***/
}
/******/
]);